import * as z from "zod";
import { wooCommerceIntegrationSchema } from "./shared";

export const getWooCommerceIntegration = {
  name: "getWooCommerceIntegration" as const,
  input: z.object({}),
  output: z.object({ integration: wooCommerceIntegrationSchema.nullable() }),
};
